export default `
    ... on ds_Socials_GlobalSet {
        id
        name
        socials_SocialLinks {
            ... on socials_SocialLinks_Url_LinkType {
                title
                text
                target
                ariaLabel
                url
                icon {
                    type
                    set
                    name
                }
            }
        }
    }
`